import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reCity/create', params),
	update                : (params) => requests.post('/reCity/update', params),
	delete                : (params) => requests.getWithParams('/reCity/delete', params),
	restore               : (params) => requests.getWithParams('/reCity/restore', params),
	getPaged              : (params) => requests.getWithParams('/reCity/getPaged', params),
	getPagedAudit         : (params) => requests.getWithParams('/reCity/getPagedAudit', params),
	getPagedAll           : (params) => requests.getWithParams('/reCity/getPagedAll', params),
	getCities         	  : (params) => requests.getWithParams('/reCity/getList', params),
}